import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function pbresult(state = initialState, action) {
  switch (action.type) {
    case actions.SET_PUBLISH_RESULT:
      return action.payload;
    default:
      return false;
  }
}
